import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'flipbook/view-example',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const Flipbook = require('./containers/Flipbook').default;
        cb(null, Flipbook)
      }, 'offer')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/Flipbook/index.js